const useUpload = () => {
  const uploadFile = async (file, fileType) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("file_type", fileType);
      const url = process.env.REACT_APP_API_URL + "/api/file/upload";
      const res = await fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      const response = await res.json();
      if (response.status && response.data) {
        return { data: response.data, success: "File uploaded successfully." };
      }
      throw new Error("Error uploading file");
    } catch (error) {
      return { error };
    }
  };

  return { uploadFile };
};

export default useUpload;
